import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import ListItem from "@mui/material/ListItem";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ListItemText from "@mui/material/ListItemText";
import { useTheme } from '@mui/material/styles';
import { ReactNode } from "react";

interface ContactItemProps {
    icon: ReactNode;
    label: string;
    // value: string | string[];
    children: ReactNode;
    // href?: string;
}

function ContactItem(props: ContactItemProps): JSX.Element {
    const theme = useTheme();

    return (
        <ListItem
            disableGutters
            sx={{ p: 0 }}
        >
            <Box
                component={ListItemAvatar}
                minWidth={'auto !important'}
                marginRight={2}
            >
                <Box
                    component={Avatar}
                    bgcolor={theme.palette.secondary.main}
                    width={40}
                    height={40}
                >
                    {props.icon}
                </Box>
            </Box>
            <ListItemText primary={props.label} secondary={props.children} />
        </ListItem>
    );
}

export default ContactItem;